// extracted by mini-css-extract-plugin
module.exports = {"layout":"PriceAndCard_layout__wcgHp","title":"PriceAndCard_title__H4vRc","content":"PriceAndCard_content__kWuAr","priceContainer":"PriceAndCard_priceContainer__MgKr1"};